export { default as vuex } from './productCategory.store'